import moment from 'moment'
import CQ9FISHActions from './CQ9FISHActions'

export default class MTActions extends CQ9FISHActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    // MT bet / settle 的 gameCode & gameName 不同
    this.betGameCode = 'MT-LIVE-002'
    this.betGameName = 'LIVE GAME'

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'MT-LIVE-037',
      platform: 'MT',
    }

    this.gameName = 'PK10 Marble PK03'
    this.roundIdPrefix = `GINKGO${moment().format('YYMMDD')}`
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameCode: this.betGameCode,
      gameName: this.betGameName,
      userId,
      platformTxId: `rel-rollout-${this.roundIdPrefix}${txnId}:cq9`, // rel-rollout-GINKGO260622000000001:cq9
      roundId: `${this.roundIdPrefix}${roundId}`, // GINKGO260622000000001
      betType: null,
      currency,
      betTime, // 2026-06-22T12:17:02.474+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      realWinAmount,
      rake,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${this.roundIdPrefix}${txnId}`, // GINKGO260622000000001
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2026-06-22T12:18:33.093+08:00
      roundId: `${this.roundIdPrefix}${roundId}`, // GINKGO260622000000001
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        roomFee: 0,
        rake,
        win: realWinAmount,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getResettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      realWinAmount,
      rake,
      resettleTime,
      debitAmount,
      creditAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${this.roundIdPrefix}${txnId}`, // GINKGO260622000000001
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime,
      roundId: `${this.roundIdPrefix}${roundId}`, // GINKGO260622000000001
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      gameInfo: {
        roomFee: 0,
        rake,
        win: realWinAmount,
        ...(debitAmount && { [`debit_resettle-${this.roundIdPrefix}${roundId}:cq9_adjustAmount`]: debitAmount }),
        ...(creditAmount && { [`credit_resettle-${this.roundIdPrefix}${roundId}:cq9_adjustAmount`]: creditAmount }),
        resettleTime,
      },
    }))

    const message = {
      action: 'resettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      gameCode: this.betGameCode,
      gameName: this.betGameName,
      userId,
      platformTxId: `rel-rollout-${this.roundIdPrefix}${txnId}:cq9`, // rel-rollout-GINKGO260622000000001:cq9
      roundId: `${this.roundIdPrefix}${roundId}`, // GINKGO260622000000001
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
